import insertScript from '@/utils/insert-script';
import insertStyle from '@/utils/insert-style';

export default function insertPreload ({ src, as, pass }) {
    if (document.createElement('link').relList) { // preload feature support inference
        let link = document.createElement('link');
        link.rel = 'preload';
        link.as = as;
        link.href = src;
        document.head.appendChild(link);
    } else {
        if (as === 'script') {
            insertScript({ src, pass });
        }
        if (as === 'style') {
            insertStyle({ src, pass });
        }
    }
}
